module.exports = __webpack_public_path__ + "img/1515268907.7c8e4c42.jpg";